export default __webpack_public_path__ + "static/media/bgimg.67da6961.jpg";